import { motion } from "framer-motion";
import { Calendar, Clock, MapPin, Shirt } from "lucide-react";
import { EVENTS } from "@/lib/wedding-data";

export default function Itinerary() {
  return (
    <section
      id="itinerary"
      data-testid="itinerary-section"
      className="scroll-mt-24 py-28 md:py-36 bg-[#5D171E] text-[#FDFBF7]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="max-w-2xl mb-20">
          <p className="text-xs uppercase tracking-[0.3em] text-[#E1C699] mb-6">
            Three Days of Celebration
          </p>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1.05]">
            The <span className="italic text-[#E1C699]">Itinerary</span>
          </h2>
          <p className="mt-6 text-base text-[#FDFBF7]/70">
            From henna-stained palms to the final farewell - here is how the
            days unfold, January 22 to 24.
          </p>
        </div>

        <div className="relative">
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px bg-[#D4AF37]/30" />
          <div className="space-y-16 md:space-y-24">
            {EVENTS.map((ev, i) => {
              const left = i % 2 === 0;
              return (
                <motion.div
                  key={ev.key}
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 0.7 }}
                  data-testid={`event-card-${ev.key}`}
                  className={`relative md:w-[calc(50%-3rem)] ${
                    left ? "md:mr-auto" : "md:ml-auto"
                  }`}
                >
                  <div
                    className={`hidden md:block absolute top-10 h-3 w-3 rotate-45 bg-[#D4AF37] ${
                      left ? "-right-[3.4rem]" : "-left-[3.4rem]"
                    }`}
                  />
                  <div className="rounded-2xl border border-[#D4AF37]/30 bg-white/5 backdrop-blur-sm p-8 md:p-10">
                    <div className="flex items-baseline justify-between gap-4">
                      <span className="font-serif italic text-5xl text-[#D4AF37]/40">
                        {ev.number}
                      </span>
                      <span className="text-[10px] uppercase tracking-[0.25em] text-[#E1C699] border border-[#D4AF37]/40 rounded-full px-4 py-2 flex items-center gap-2">
                        <Shirt className="h-3 w-3" />
                        {ev.dress}
                      </span>
                    </div>
                    <h3 className="mt-6 font-serif text-3xl md:text-4xl tracking-tight">
                      {ev.name}
                    </h3>
                    <p className="mt-4 text-sm text-[#FDFBF7]/70 leading-relaxed">
                      {ev.blurb}
                    </p>
                    <div className="mt-8 space-y-3 text-sm text-[#FDFBF7]/85">
                      <p className="flex items-center gap-3">
                        <Calendar className="h-4 w-4 text-[#E1C699]" />
                        {ev.date}
                      </p>
                      <p className="flex items-center gap-3">
                        <Clock className="h-4 w-4 text-[#E1C699]" />
                        {ev.time}
                      </p>
                      <p className="flex items-center gap-3">
                        <MapPin className="h-4 w-4 text-[#E1C699]" />
                        {ev.venue}
                      </p>
                    </div>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
